import React from 'react'

export default () => <div className="inline-loader" />
